export default __webpack_public_path__ + "static/media/cobertura.da43b20f.svg";